/**
 * OAuth app used for first-party login (password grant and MFA).
 * Default credentials; override with VITE_OAUTH_CLIENT_ID / VITE_OAUTH_CLIENT_SECRET env vars.
 */

const env = ((import.meta as any).env ?? {}) as Record<
  string,
  string | undefined
>;

export const oauthApp = {
  client_id:
    env.VITE_OAUTH_CLIENT_ID || "9X1Fdd-pxNsAgEDNi_SfhJWi8T-vLuV2WVzKIbkTCw4",
  client_secret:
    env.VITE_OAUTH_CLIENT_SECRET ||
    "ozF8jzI4968oTKFkEnsBC-UbLPCdrSv0MkXGQu2o_-M",
  redirect_uri: "urn:ietf:wg:oauth:2.0:oob",
} as const;
